//GeneratorFlag:[NoChange]
import Producer from './producer';
import ProducerFilter from './producer-filter';

export default {Producer, ProducerFilter}
export{Producer, ProducerFilter}